module.exports = __webpack_public_path__ + "static/staff_of_fire-d5ae12348e79e4fd9f6e34e0ad1555b5.jpeg";